import { useState } from 'react'
import { Button, DateField, Label } from '@atrvd/saas-ui'
import { isCalendarDate } from '@dcp/shared/utils/business-date'

interface ProjectionBulkDateActionProps {
  /** A bulk write is in flight; DataTable's `bulkActionsDisabled` does not reach a custom action. */
  busy: boolean
  onApply: (date: string) => void
}

/**
 * The bulk bar's "Projected payment date" field and its Apply button (a
 * DataTable custom bulk action). The bar unmounts it when the selection
 * empties, so the date starts empty for every new selection; it is kept after
 * a failed Apply, for a retry.
 */
export function ProjectionBulkDateAction({ busy, onApply }: ProjectionBulkDateActionProps) {
  const [date, setDate] = useState('')

  return (
    <div className="flex items-center gap-2">
      <Label htmlFor="bulk-projected-payment-date" className="whitespace-nowrap font-normal">
        Projected payment date
      </Label>
      <div className="w-40">
        <DateField id="bulk-projected-payment-date" value={date} onValueChange={setDate} disabled={busy} className="h-8" />
      </div>
      <Button type="button" size="sm" onClick={() => onApply(date)} disabled={!isCalendarDate(date) || busy}>
        Apply
      </Button>
    </div>
  )
}
